import { ColumnDirective, ColumnsDirective, ColumnChooser, ExcelExport, ExcelFilter, Filter, GridComponent, Inject, Page, Sort, Toolbar } from "@syncfusion/ej2-react-grids";
import { useContext } from "react";
import AuthContext from "../../context/authProvider";
import { renderGradeValueForTable } from "../utils/serialGradeFields";

const SerialsList = ({ serials, setEdit, setEditableSerial }) => {

    const { user } = useContext(AuthContext);

    let grid;

    const handleEdit = (serial) => {
        setEdit(true);
        setEditableSerial(serial);
    }

    const filterSettings = { type: 'Excel' };

    let toolbarOptions = ['ColumnChooser'];
    let allowExcelExport = false;

    if (user.roles.includes("master")) {
        toolbarOptions = ['ExcelExport', 'ColumnChooser'];
        allowExcelExport = true;
    }


    const toolbarClick = (args) => {
        console.log("Tollbar clicked.");
        if (grid && args.item.id === 'Grid_excelexport') {
            console.log("Tollbar clicked. => Grid_excelexport");
            grid.excelExport();
        }
    };

    return (
        <GridComponent id='Grid' toolbar={toolbarOptions} dataSource={serials} filterSettings={filterSettings} allowExcelExport={allowExcelExport} allowFiltering allowSorting allowPaging showColumnChooser pageSettings={{ pageSize: 30 }} toolbarClick={toolbarClick} ref={g => grid = g}>
            <ColumnsDirective>
                <ColumnDirective field='gradedAt' width='100' headerText="Avaliado" textAlign="Center" type="date" format="dd/MM/yyyy" />
                <ColumnDirective field='gradableModel.game' headerText="Jogo" width='100' textAlign="Center" />
                <ColumnDirective field='gradableModel.edition' width='100' headerText="Edição" textAlign="Center" />
                <ColumnDirective field='gradableModel.year' width='100' headerText="Ano" textAlign="Center" />
                <ColumnDirective field='gradableModel.name' width='100' headerText="Nome" textAlign="Center" />
                <ColumnDirective visible={false} field='gradableModel.language' width='100' headerText="Idioma" textAlign="Center" />
                <ColumnDirective visible={false} field='gradableModel.numbering' width='100' headerText="Numeração" textAlign="Center" />
                <ColumnDirective visible={false} field='gradableModel.rarity' width='100' headerText="Raridade" textAlign="Center" />
                <ColumnDirective field='serialNumber' width='100' headerText="Serial" textAlign="Center" />
                <ColumnDirective field='generalScore' width='100' headerText="Nota Geral" textAlign="Center" valueAccessor={(f, d) => renderGradeValueForTable(d, "generalScore", d?.product || d?.productData)} />
                <ColumnDirective field='notaAutografo' width='100' headerText="Nota Autógrafo" textAlign="Center" valueAccessor={(f, d) => renderGradeValueForTable(d, "notaAutografo", d?.product || d?.productData)} />
                <ColumnDirective visible={false} field='centering' width='100' headerText="Centering" textAlign="Center" valueAccessor={(f, d) => renderGradeValueForTable(d, "centering", d?.product || d?.productData)} />
                <ColumnDirective visible={false} field='corners' width='100' headerText="Corners" textAlign="Center" valueAccessor={(f, d) => renderGradeValueForTable(d, "corners", d?.product || d?.productData)} />
                <ColumnDirective visible={false} field='edges' width='100' headerText="Edges" textAlign="Center" valueAccessor={(f, d) => renderGradeValueForTable(d, "edges", d?.product || d?.productData)} />
                <ColumnDirective visible={false} field='surface' width='100' headerText="Surface" textAlign="Center" valueAccessor={(f, d) => renderGradeValueForTable(d, "surface", d?.product || d?.productData)} />
                <ColumnDirective headerText="Ação" width='100' textAlign="Center" template={(d, f) => { return <button onClick={() => handleEdit(d)} className="bg-blue-500 hover:bg-blue-800 px-2 text-black">Ver</button> }} />
            </ColumnsDirective>
            <Inject services={[Toolbar, Sort, Page, ColumnChooser, Filter, ExcelExport, ExcelFilter]} />
        </GridComponent>
    )
}

export default SerialsList;
